// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Aufklappbare Übungs-Vorschau: GIF, Nutzen, Ausführung, Video-Link
import { useState } from "react"
import type { Exercise } from "@/lib/types"

export default function ExercisePeek({ exercise }: { exercise: Exercise }) {
  const [open, setOpen] = useState(false)
  return (
    <div className="peek">
      <button type="button" className="peek-toggle" aria-expanded={open} onClick={() => setOpen(!open)}>
        Übung ansehen {open ? "▾" : "▸"}
      </button>
      {open && (
        <div className="peek-body">
          {exercise.media_slug !== "" && (
            <img
              src={`/media/exercises/${exercise.media_slug}.gif`}
              alt={exercise.name}
              loading="lazy"
              width={180}
              height={180}
              onError={(e) => { e.currentTarget.style.display = "none" }}
            />
          )}
          {exercise.benefit_text !== "" && <p><b>Was bringt's:</b> {exercise.benefit_text}</p>}
          {exercise.execution_text !== "" && <p><b>Ausführung:</b> {exercise.execution_text}</p>}
          {exercise.video_search_term !== "" && (
            <a
              href={`https://www.youtube.com/results?search_query=${encodeURIComponent(exercise.video_search_term)}`}
              target="_blank"
              rel="noreferrer"
            >Video ansehen ↗</a>
          )}
        </div>
      )}
    </div>
  )
}
